import { render, staticRenderFns } from "./BppList.vue?vue&type=template&id=7dd1ac0a&"
import script from "./BppList.vue?vue&type=script&lang=js&"
export * from "./BppList.vue?vue&type=script&lang=js&"
import style0 from "@/assets/styles/jqwidgets/jqx.base.css?vue&type=style&index=0&lang=css&"
import style1 from "@/assets/styles/jqwidgets/jqx.material-green.css?vue&type=style&index=1&lang=css&"
import style2 from "./BppList.vue?vue&type=style&index=2&lang=stylus&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports